const ITEMS = ["Criterio", "Técnica NAGI", "La Gomera", "Naturalidad", "Precisión", "Sin efecto tatuaje", "Arte"];

const Marquee = ({ dark = true }) => (
  <div
    className={`overflow-hidden border-y ${dark ? "bg-ink border-gold/20" : "bg-beige border-sand"} py-5`}
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1, 2].map((rep) => (
        <div key={rep} className="flex items-center shrink-0">
          {ITEMS.map((item, i) => (
            <span key={`${rep}-${i}`} className="flex items-center">
              <span className={`font-serif italic text-2xl sm:text-3xl px-8 ${dark ? "text-cream/80" : "text-ink/70"}`}>
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
